import React from "react";

import Selectors from "common_components/flowmaster/llm_run/selectors";
import Field from "common_components/flowmaster/llm_run/filtering/filter_field";

import {LlmRunFilterKeys} from "common/flowmaster/types/llm_run";
import {LlmRunQueryParams} from "routes/llm_run/utils/filtering/get_llm_run_query_params";

type Props = {
  filters: LlmRunQueryParams;
  updateValue: (
    obj: Partial<Record<LlmRunFilterKeys, string | number>>,
  ) => void;
  keys: LlmRunFilterKeys[];
};

export default function Filters({filters, updateValue, keys}: Props) {
  return (
    <div style={{display: "flex", justifyContent: "end"}}>
      <div>
        <Field
          label="Min Test Runs"
          value={filters.min_test_runs}
          updator={value => updateValue({min_test_runs: value})}
        />
      </div>
      <Selectors values={filters} updateValue={updateValue} keys={keys} />
    </div>
  );
}
